import type { JSX } from 'react';

export function ErrorPage(): JSX.Element {
  return (
    <main className="co-container">
      <div className="co-card co-center">
        <h1>Something went wrong</h1>
        <p className="co-muted">
          We were unable to process this page. Your card has not been charged.
        </p>
      </div>
    </main>
  );
}
